import moment from 'moment';

export const formatDate = (initialDate, includeTime, format) => {
  const formatString = includeTime ? 'DD/MM/YYYY hh:mm A' : 'DD/MM/YYYY';
  const formatted = moment(initialDate).format(format || formatString);
  return formatted;
};
